exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-body {\n  padding-bottom: 15px; }\n\nform {\n  min-height: 74px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?{"includePaths":["/root/src/ui","/root/src/ui/node_modules"]}!./~/import-glob-loader!./app/common/folder-tree/folder-form.component.sass
// module id = 1092
// module chunks = 4